module.exports = __webpack_public_path__ + "img/section4_pic2@3x.80676b39.png";